import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { provideTranslateService, provideTranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { anonymousInterceptor } from '@core/interceptors/anonymous.interceptor';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';
import { clarityInterceptor } from '@core/analytics/clarity.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'top',
                anchorScrolling: 'enabled'
            })
        ),
        provideHttpClient(
            withFetch(),
            withInterceptors([
                authInterceptor,
                anonymousInterceptor,
                loadingInterceptor,
                clarityInterceptor
            ])
        ),
        provideClientHydration(withEventReplay()),
        provideTranslateService({
            loader: provideTranslateLoader(TranslateHttpLoader),
        }),
        ...provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
        provideAnimationsAsync(),
        provideToastr({
            timeOut: 5000,
            progressBar: true,
            positionClass: 'toast-bottom-left',
        }),
    ]
};
